export default {"src":"/uk/_next/static/media/email.468d7c62.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};